import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';

import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { HierarchyService } from '../services/hierarchy.service';
import { MyTeamDetailsSearchHandler } from './my-team-details-search.handler';

@Component({
  selector: 'sym-my-team-details-search',
  templateUrl: './my-team-details-search.component.html',
  styleUrls: ['./my-team-details-search.component.scss'],
})
export class MyTeamDetailsSearchComponent extends MyTeamDetailsSearchHandler implements OnInit {

  constructor( 
    public service: HierarchyService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService
  ){
    super(service, headerService, router, settingService);
  }
  
  ngOnInit() {
  super.ngOnInit();
  }
}
